/**
 * Keycloak wiring for the vikingvault realm.
 *
 * This is a public client using authorization code + PKCE. It holds no secret:
 * a browser cannot keep one, and the API only ever verifies signatures against
 * the realm's JWKS. (The older samlaget-web SPA in this repo is configured as a
 * confidential client -- do not copy that pattern here.)
 */

import Keycloak from 'keycloak-js';

import { config } from './config';

export const keycloak = new Keycloak({
  url: config.keycloakUrl,
  realm: config.keycloakRealm,
  clientId: config.keycloakClientId,
});

/** Starts the login flow and resolves once an identity is established. */
export async function initKeycloak(): Promise<boolean> {
  return keycloak.init({
    onLoad: 'login-required',
    pkceMethod: 'S256',
    checkLoginIframe: false,
  });
}

/**
 * A token guaranteed to be valid for at least a few more seconds.
 *
 * Refreshing on the way out of the door beats reacting to a 401: an expiry
 * midway through a save would otherwise lose the user's edit.
 */
export async function freshToken(): Promise<string> {
  try {
    await keycloak.updateToken(30);
  } catch {
    // The refresh token is gone or rejected -- there is nothing to do but
    // send them back to Keycloak.
    await keycloak.login();
  }
  return keycloak.token ?? '';
}

export function logout(): void {
  void keycloak.logout({ redirectUri: window.location.origin });
}
